exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "div.row{margin-top:20px}div.row fieldset{width:100%}div.row legend{font-family:Perpetua;font-size:2rem}button{height:56px;width:170px;border-radius:2px}jhi-button[cancellation]{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/account/register/personne-morale/personne-morale.component.scss
// module id = 661
// module chunks = 0